import * as React from "react"
import styled from "styled-components"
import H3 from "../../../atoms/typography/H3"
import Body from "../../../atoms/typography/Body"
import { HorizontalSpacer, Spacer } from "../../../atoms/spacers"
import { calculateItemTotal, getFormattedPrice } from "../../../../utils/cart-helpers"
import { CartStructure } from "../../../interfaces/SaleorTypes"
import Counter from "../../Counter"
import SmallButton from "../../../atoms/buttons/SmallButton"
import { MinusIcon } from "../../../atoms/icons/MinusIcon"

interface CartSolutionSectionProps {
  accessory: CartStructure
  removeFromCart: (products: CartStructure[]) => void
  addToCart: (products: CartStructure[]) => void
  editable?: boolean
}

const Image = styled.img`
  width: 56px;
  height: 56px;
  object-fit: contain;
`

const FlexContainer = styled.div`
  display: flex;
  align-items: center;
`

const SpaceAndAlignCenter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const CartAccessorySection: React.FC<CartSolutionSectionProps> = ({
  accessory,
  addToCart,
  removeFromCart,
  editable,
}) => {
  const onClickAddOne = () => {
    addToCart([{ product: accessory.product, amount: 1 }])
  }
  const onClickRemoveOne = () => {
    removeFromCart([{ product: accessory.product, amount: 1 }])
  }

  const onClickRemoveAccessory = () => {
    removeFromCart([accessory])
  }

  return (
    <div>
      <SpaceAndAlignCenter>
        <FlexContainer>
          <Image src={accessory.product.media[0]?.url} />
          <Spacer spacing={1.75} />
          <H3>{accessory.product.name}</H3>
        </FlexContainer>
        {editable && <SmallButton title="Remove" leftIcon={<MinusIcon />} onClick={onClickRemoveAccessory} />}
      </SpaceAndAlignCenter>
      <HorizontalSpacer spacing={0.5} />
      <SpaceAndAlignCenter>
        <Body>Quantity:</Body>
        {editable ? (
          <Counter
            minValue={1}
            currentValue={accessory.amount}
            onClickMinus={onClickRemoveOne}
            onClickAdd={onClickAddOne}
          />
        ) : (
          <Body>{accessory.amount}</Body>
        )}
      </SpaceAndAlignCenter>
      <HorizontalSpacer spacing={0.5} />
      <SpaceAndAlignCenter>
        <Body>Price:</Body>
        <Body>
          {`${getFormattedPrice(
            calculateItemTotal(accessory.product, accessory.amount),
            accessory.product.variants[0].pricing.price.currency,
          )}`}
        </Body>
      </SpaceAndAlignCenter>
      <HorizontalSpacer spacing={1.5} />
    </div>
  )
}

export default CartAccessorySection
